import resim1 from '../assets/img/ikamearac/mobil-assistance-kurumlara-cozumler.jpeg'

export default function IkameAracHizmeti() {
    return (
        <>
            <section id="c-know-us" className="standard-section">
                <div className="standard-container">
                    <div className="standard-section-title">
                        <div className="standard-section-title__sub-title" data-aos="fade-up" data-aos-delay="200">
                            MOBİL ASSİSTANCE: HAZIR SİSTEM, HIZLI BAŞLANGIÇ
                        </div>
                        <div className="standard-section-title__main" data-aos="fade-up" data-aos-delay="400">
                            <div className="standard-section-title__main--desc">
                                <h3>Mobil Assistance ile Assistance Firmalarına Altyapı Desteği!</h3>
                                <p>Mobil Assistance, kendi assistance firmasını kurmak isteyen girişimcilere güçlü bir altyapı, profesyonel çağrı merkezi hizmeti ve gelişmiş yazılım desteği sunar. Assistance altyapı desteği, müşteri yönetimini, operasyonel süreçleri ve teknik entegrasyonları tek bir çatı altında birleştirerek sunar. Firmalar hazır sistemler ile güvenli ve kolay bir şekilde pazara giriş yapabilir.</p>
                            </div>
                        </div>
                    </div>


                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 col-md-10">
                            <img src={resim1} className="img-fluid rounded shadow" alt='Mobil Assistance' />
                        </div>
                    </div>

                    <div className="text-center">
                        <a className="modern-cta-button" href="/tr/hizmetlerimiz">DAHA FAZLASI İÇİN →</a>
                    </div>
                </div>
            </section>
        </>
    );
} 